import type {
  CloudEnvironmentCatalogRow,
  CloudProjectCatalogRow,
} from "../../cmmd/cmmdForgeRuntimeListResource";
import type { CmmdForgeRuntimeLifecycleAction } from "../../environments/primary/cmmdForgeRuntimeApi";
import { readForgeCloudEnvironmentLabelForRow } from "../../environments/forgeCloudEnvironmentLabel";

/**
 * What a toast calls the Environment an action ran on.
 *
 * A project row carries no Environment naming, so it is named by its Project.
 */
export function lifecycleTargetName(
  row: CloudProjectCatalogRow | CloudEnvironmentCatalogRow,
): string {
  if ("cmmdProjectId" in row) return `the Environment for ${row.projectName}`;
  return readForgeCloudEnvironmentLabelForRow(row);
}

/** The person-facing word for a lifecycle action. */
export function lifecycleActionWord(action: CmmdForgeRuntimeLifecycleAction): string {
  if (action === "start") return "resume";
  return action === "stop" ? "pause" : "recycle";
}

/** The success title, which names the Environment so a toast cannot be misread. */
export function lifecycleActionTitle(
  action: CmmdForgeRuntimeLifecycleAction,
  wakeNow: boolean,
  targetName: string,
): string {
  if (wakeNow) return `${targetName} is awake`;
  const word = lifecycleActionWord(action);
  return `${word.charAt(0).toUpperCase()}${word.slice(1)} requested for ${targetName}`;
}
